<div class="main-layout mx-auto">
  <div [style]="animationStyles" class="Splash relative flex flex-column align-items-center justify-content-center gap-3 z-4">
    <div class="mask absolute z-2">
      <svg viewBox="0 0 375 678" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="s-path" fill-rule="evenodd" clip-rule="evenodd" d="M375 0H0V678H375V0ZM181.3 239.962C159.103 239.962 158.641 232.258 158.333 224.046L174.225 224.024C175.229 224.056 175.893 224.706 176.09 225.853C176.176 226.999 176.569 228.099 177.226 229.034C178.097 230.045 179.877 230.657 181.874 230.657H184.615C184.849 230.684 184.971 230.889 184.971 231.284L184.939 238.247C184.939 239.28 184.487 239.832 183.558 239.962C182.984 239.941 182.409 239.953 181.837 240L181.874 239.962H181.3ZM184.764 208.194L195.6 191.087L215.21 191.071L198.781 215.46L217 239.085H196.37L184.057 222.314C183.225 221.984 182.336 221.637 181.409 221.274C174.156 218.436 164.53 214.671 160.946 211.164C158.519 208.805 157.892 205.408 158.014 202.703C158.461 192.278 167.368 189.275 186.081 190.141C186.081 190.141 186.91 190.162 186.888 190.714C186.867 191.266 186.57 197.953 186.57 197.953C186.543 199.17 185.438 199.327 184.445 199.284L181.386 199.148C178.56 199.121 176.818 200.441 176.722 202.605C176.672 203.333 176.875 204.055 177.296 204.645C178.108 205.657 181.099 206.831 184.626 208.145L184.764 208.194Z" fill="white"/>
      </svg>
    </div>

    <div id="splashContent" class="flex flex-column align-items-center gap-3 z-3 mt-8">
      <img class="passfeet-logo" src="assets/imgs/passfeet-logo.png" alt="Skiset Logo" />
      <p class="my-0">L’innovation au service des clients</p>
      <span class="flex align-items-center gap-3">
        par
        <img class="skiset-logo" src="assets/imgs/skiset-logo.png" alt="Skiset Logo" />
      </span>
    </div>

    <div class="language-selection fixed justify-content-between z-3" style="display: none;">
      <div class="language flex align-items-center gap-2 cursor-pointer" data-lang="fr">
        <img src="/assets/imgs/flags/fr-flag.png" alt="French">
        <span class="text-xxs">Français</span>
      </div>
      <div class="language flex align-items-center gap-2 cursor-pointer" data-lang="en">
        <img src="/assets/imgs/flags/en-flag.png" alt="English">
        <span class="text-xxs">English</span>
      </div>
    </div>
  </div>
  <app-layout-header *ngIf="headerConfig.useHeader"></app-layout-header>
  <div #mainContent class="main-content" [ngClass]="{'no-header': !headerConfig.useHeader}">
    <!-- <div class="p-3 flex flex-wrap gap-3">
      <i class="icon icon-arrow-left"></i>
      <i class="icon icon-burger"></i>
      <i class="icon icon-grid"></i>
      <i class="icon icon-list"></i>
      <i class="icon icon-arrow-right"></i>
      <i class="icon icon-avatar"></i>
      <i class="icon icon-booking"></i>
      <i class="icon icon-close"></i>
      <i class="icon icon-heart-filled"></i>
      <i class="icon icon-locker"></i>
      <i class="icon icon-logout"></i>
      <i class="icon icon-mail"></i>
      <i class="icon icon-plus"></i>
      <i class="icon icon-smart-phone"></i>
      <i class="icon icon-sad-face"></i>
      <i class="icon icon-normal-face"></i>
      <i class="icon icon-smile-face"></i>
      <i class="icon icon-happy-face"></i>
    </div> -->

    <router-outlet></router-outlet>
    <app-layout-footer></app-layout-footer>
  </div>
</div>

<p-confirmDialog key="commonError" #commonError>
  <ng-template pTemplate="headless" let-message>
    <div class="flex flex-column align-items-center p-4 surface-overlay border-round">
      <span class="header text-xs text-error font-medium block">
        {{ 'COMMON.error_occurred' | translate }}!
      </span>
      <p class="message mb-0 text-xs font-normal text-center">{{ 'COMMON.error_occurred_msg' | translate }}</p>
      <div class="flex align-items-center gap-2 mt-4">
        <button
          pButton
          [label]="'COMMON.close' | translate"
          (click)="commonError.accept()"
          severity="danger"
          [rounded]="true"
          class="w-8rem">
        </button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog key="confirmLinkGuest" [closeOnEscape]="true" #confirmLinkGuest>
  <ng-template pTemplate="headless" let-message>
    <div class="confirm-logout flex flex-column align-items-center p-4 surface-overlay border-round">
      <span class="header text-xs text-center font-medium block">
        {{ 'LINK_GUEST.replace_save_data' | translate }}
      </span>
      <p class="message mb-0 text-xs font-normal text-center">{{ 'LINK_GUEST.confirm_link_guest_msg' | translate }}</p>
      <div class="flex align-items-center gap-2 mt-4">
        <button
          pButton
          [label]="'COMMON.cancel' | translate"
          (click)="confirmLinkGuest.reject()"
          severity="secondary"
          [rounded]="true"
          class="p-button-outlined w-8rem ">
        </button>
        <button
          pButton
          [label]="'COMMON.ok' | translate"
          (click)="confirmLinkGuest.accept()"
          severity="success"
          [rounded]="true"
          class="w-8rem">
        </button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog key="linkCodeError" [closeOnEscape]="true" #linkCodeError>
  <ng-template pTemplate="headless" let-message>
    <div class="confirm-logout flex flex-column align-items-center p-4 surface-overlay border-round">
      <span class="header text-xs text-center font-medium block">
        {{ 'COMMON.error_occurred' | translate }}
      </span>
      <p class="message mb-0 text-xs font-normal text-center">{{ 'LINK_GUEST.link_code_error' | translate }}</p>
      <div class="flex align-items-center gap-2 mt-4">
        <button
          pButton
          [label]="'COMMON.close' | translate"
          (click)="linkCodeError.accept()"
          severity="danger"
          [rounded]="true"
          class="w-8rem">
        </button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
